// extracted by mini-css-extract-plugin
export default {"problem":"SorryTheresAProblem_problem__1VfWD"};